import "../../styles/bootstrap/bootstrap-popover.scss";
import "../../styles/popoverOverride.scss";
import "./formList.scss";

import PropTypes from "prop-types";
import React, { createRef, Fragment } from "react";
import { PopoverBody } from "reactstrap";

import NavigationToolbar from "../../components/navigationToolbar";
import { withScreenContext } from "../../components/screen/ScreenContext";
import keyConstants from "../../constants/keyConstants";
import { isScreenModeMobile } from "../../constants/screenModes";
import { PropTypeShapes } from "../../types";
import Icon from "../interface/Icon";
import ListView from "../listView/ListView";
import { popoverOrPortal } from "../portal/popoverOrPortal";
import FormDependencyListItem from "./FormDependencyListItem";
import FormListButtonWrapper from "./FormListButtonWrapper";
import FormSearchField from "./FormSearchField";
import { getFilteredOptions } from "./utils";

class FormDependencyList extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      popoverOpen: false,
      searchText: "",
      resolvePopoverOpen: false,
      highlightedOptionIndex: -1
    };
    this.searchChanged = this.searchChanged.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onDownArrow = this.onDownArrow.bind(this);
    this.optionRenderer = this.optionRenderer.bind(this);

    this._listViewDom = null;
    this._searchRef = createRef();
  }

  toggle() {
    const { popoverOpen } = this.state;
    const { onTogglePopover } = this.props;
    this.setState({
      popoverOpen: !popoverOpen,
      searchText: ""
    });
    if (onTogglePopover) {
      onTogglePopover(!popoverOpen);
    }
  }

  optionClick(opt, value) {
    if (this.props.closeOnClick) {
      this.toggle();
    }
    if (value) {
      this.props.onAddItem(opt);
    } else {
      this.props.onDeleteItem(opt);
    }
  }

  searchChanged(value) {
    this.setState({ searchText: value, highlightedOptionIndex: -1 });
  }

  renderOptionIcon(opt) {
    if (opt.icon) {
      return (
        <div className="formListIcon">
          <svg className={`icon ${opt.color ? opt.color : "mono"}`}>
            <use xlinkHref={`#${opt.icon}`} />
          </svg>
        </div>
      );
    } else if (opt.color) {
      return <div className={`formListColor ${opt.color}`} />;
    } else {
      return null;
    }
  }

  onDownArrow() {
    this._listViewDom ? this._listViewDom.focus() : null;
    this.setState({ highlightedOptionIndex: 0 });
  }

  onKeyDown(e) {
    if (e.key !== keyConstants.Down || e.key !== keyConstants.Up) {
      this._searchRef && this._searchRef.current ? this._searchRef.current.focus() : null;
    }
  }

  optionRenderer(opt, isHighlighted, ref) {
    const optClass = `formListMenuOption ${isHighlighted ? "selected" : ""}`;
    const selected = this.props.values.findIndex(v => v.value === opt.value) >= 0;
    return (
      <div ref={ref} className={optClass} key={opt.value} onClick={() => this.optionClick(opt.value, !selected)}>
        <div className="formListTick">
          <svg className="icon mono">
            <use xlinkHref={selected ? "#tick" : "#blank"} />
          </svg>
        </div>
        {this.renderOptionIcon(opt)}
        <div className="formListLabel">{opt.label}</div>
      </div>
    );
  }

  onItemSelectIndex(newIndex, filterOptions) {
    const opt = filterOptions.find((item, index) => index === newIndex);
    const isValueSelected = this.props.values.findIndex(v => v.value === opt.value) >= 0;
    this.optionClick(opt.value, !isValueSelected);
  }

  getListView() {
    const filterOptions = getFilteredOptions(this.props.options, this.state.searchText);

    const selectedIndex = this.state.highlightedOptionIndex;

    const onItemSelect = newIndex => this.onItemSelectIndex(newIndex, filterOptions);

    return (
      <ListView
        className="formListMenuOptions"
        items={filterOptions}
        selectedItemIndex={selectedIndex}
        onItemSelect={onItemSelect}
        itemRenderer={this.optionRenderer}
        getDom={listViewDom => (this._listViewDom = listViewDom)}
      />
    );
  }

  renderMenuSearch() {
    if (this.props.allowSearch) {
      return (
        <FormSearchField
          //#!if iOS !== true
          autoFocus={true}
          //#!endif
          ref={this._searchRef}
          placeholder="Filter"
          value={this.state.searchText}
          onChange={this.searchChanged}
          onDownArrow={this.onDownArrow}
          continuouslyUpdates={true}
          showSearchIcon={true}
          showClearIcon={true}
        />
      );
    }
    return null;
  }

  renderMenu() {
    if (this.state.popoverOpen) {
      return (
        <div>
          <div className={`formListMenu ${this.props.allowSearch ? "" : "noSearch"}`} onKeyDown={this.onKeyDown}>
            {this.renderMenuSearch()}
            {this.getListView()}
          </div>
        </div>
      );
    }
    return null;
  }

  renderVisibleList() {
    return this.props.values.map(listItem => {
      return (
        <FormDependencyListItem
          key={listItem.value}
          {...listItem}
          subOptions={this.props.subOptions}
          onSubValueChange={this.props.onSubValueChange}
          onItemClick={this.props.onItemClick}
          onDeleteItem={this.props.onDeleteItem}
          onChooseResolution={this.props.onResolveConstraintUsingOption}
          canDelete={this.props.canDelete}
          title="Timeline Dependency"
        />
      );
    });
  }

  renderEmptyLabel() {
    return this.props.values.length === 0 && this.props.emptyLabel ? (
      <div className="formListEmptyLabel">{this.props.emptyLabel}</div>
    ) : null;
  }

  renderPopover() {
    let placement = "bottom-start";
    let hideArrow = false;
    let alwaysPortal = false;
    //#!if tablet === true
// placement = "right-start";
    //#!endif

    let popoverOptions = {
      className: `inspectorPopover`,
      placement,
      hideArrow,
      isOpen: this.state.popoverOpen,
      target: this.props.id,
      toggle: this.toggle,
      boundariesElement: "viewport"
    };

    const child = (
      <Fragment>
        {this.props.screenContext && isScreenModeMobile(this.props.screenContext.screenMode) ? (
          <NavigationToolbar
            title={this.props.title}
            showBack={true}
            showBackArrow={true}
            onBackClick={this.toggle}
            backText={this.props.backText ? this.props.backText : "Back"}
            flexLeft={1}
            flexCenter={3}
            flexRight={1}
          />
        ) : null}
        <PopoverBody onClick={e => e.stopPropagation()}>{this.renderMenu()}</PopoverBody>
      </Fragment>
    );

    return popoverOrPortal(child, popoverOptions, alwaysPortal);
  }

  render() {
    return (
      <div className="formListWrapper">
        {this.renderVisibleList()}
        <div id={this.props.id}>
          <FormListButtonWrapper className="formListAddWrapper" onClick={this.toggle}>
            <Icon
              icon="listAdd"
              color="iconMono"
              pulse={this.props.pulsateIconId && this.props.pulsateIconId === this.props.addInterfaceIdentifier}
            />
            {this.renderEmptyLabel()}
          </FormListButtonWrapper>
        </div>
        {this.state.popoverOpen ? <div className="formListBackdrop" onClick={this.toggle} /> : null}
        {this.state.popoverOpen ? this.renderPopover() : null}
      </div>
    );
  }
}

FormDependencyList.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypeShapes.listOptionArray.isRequired,
  subOptions: PropTypeShapes.listOptionArray.isRequired,
  values: PropTypeShapes.formListValueArray.isRequired,
  emptyLabel: PropTypes.string,
  onDeleteItem: PropTypes.func.isRequired,
  onAddItem: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
  onSubValueChange: PropTypes.func.isRequired,
  onResolveConstraintUsingOption: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  canDelete: PropTypes.bool,
  allowSearch: PropTypes.bool,
  closeOnClick: PropTypes.bool,
  title: PropTypes.string,
  backText: PropTypes.string,
  onTogglePopover: PropTypes.func,

  addInterfaceIdentifier: PropTypes.string,
  pulsateIconId: PropTypes.string,

  //#!if iOS === true
  // From withScreenContext
// screenContext: PropTypes.object
  //#!endif
};

let exportedView = FormDependencyList;
//#!if iOS === true
// exportedView = withScreenContext(FormDependencyList);
//#!endif
export default exportedView;
